<template>
  <div class="why-us">
    <div
      class="why-us_banner"
      :style="{
        backgroundImage:
          'url(' +
          require('../../../assets/images/why-us/' + imgUrl + '.png') +
          ')',
      }"
    >
      <h2 class="why-us_banner_title">
        {{ nameUrl }}
      </h2>
      <div class="why-us_banner_sub-title">Why us</div>
    </div>
    <tabs @name="setName">
      <tab name="story">
        <h1>Story</h1>
      </tab>
      <tab name="network">
        <h1>Network</h1>
      </tab>
      <tab name="management-philosophy" :selected="true">
        <management-philosophy :card="whyUs['management-philosophy'].cards" />
      </tab>
      <tab name="corporate-social-responsibility">
        <corporate-social-responsibility
          :cards="whyUs['corporate-social-responsibility'].cards"
        />
      </tab>
    </tabs>
  </div>
</template>

<script>
import { reactive, ref, computed } from "@vue/composition-api";
// import { useRoute } from "vue-router";
export default {
  name: "WhyUs",
  components: {
    Tabs: () => import("@/@core/components/tabs"),
    Tab: () => import("@/@core/components/tab"),
    ManagementPhilosophy: () => import("./components/management-philosophy"),
    CorporateSocialResponsibility: () =>
      import("./components/corporate-social-responsibility"),
  },
  created() {
  },
  setup(props) {
    const onNameUrl = ref("");
    const whyUs = reactive({
      "management-philosophy": {
        name: "MANAGEMENT PHILOSOPHY",
        img: "management-philosophy",
        cards: [
          {
            title: "Mission",
            sub_title:
              "WR1 an inclusive economic development, combining distinctive elements of its know-how with principles inspired by the enhancement of people, the respect of ethical values, the promotion of local culture and the protection of the environment.",
            sub_title_2:
              "Sustainability is a founding element deeply rooted in the Company’s identity and strategy, which represents a formal commitment towards the communities in which it operates.",
          },
          {
            title: "Vission",
            sub_title:
              "WR1 an inclusive economic development, combining distinctive elements of its know-how with principles inspired by the enhancement of people, the respect of ethical values, the promotion of local culture and the protection of the environment.",
            sub_title_2:
              "Sustainability is a founding element deeply rooted in the Company’s identity and strategy, which represents a formal commitment towards the communities in which it operates.",
          },
          {
            title: "Core Value",
            sub_title:
              "WR1 an inclusive economic development, combining distinctive elements of its know-how with principles inspired by the enhancement of people, the respect of ethical values, the promotion of local culture and the protection of the environment.",
            sub_title_2:
              "Sustainability is a founding element deeply rooted in the Company’s identity and strategy, which represents a formal commitment towards the communities in which it operates.",
          },
        ],
      },
      "corporate-social-responsibility": {
        name: "corporate social responsibility",
        img: "corporate-social-responsibility",
        cards: [
          {
            text_1:
              "WR1 an inclusive economic development, combining distinctive elements of its know-how with principles inspired by the enhancement of people, the respect of ethical values, the promotion of local culture and the protection of the environment.",
            text_2:
              "WR1 an inclusive economic development, combining distinctive elements of its know-how with principles inspired by the enhancement of people, the respect of ethical values, the promotion of local culture and the protection of the environment.",
            sub_title:
              "WR1 an inclusive economic development, combining distinctive elements of its know-how with principles inspired by the enhancement of people, the respect of ethical values, the promotion of local culture and the protection of the environment.",
          },
        ],
      },
    });
    function setName(name) {
      onNameUrl.value = name;
    }
    const imgUrl = computed(
      () => whyUs[onNameUrl.value]?.img || "management-philosophy"
    );

    const nameUrl = computed(() => whyUs[onNameUrl.value]?.name || "");

    return {
      whyUs,
      setName,
      onNameUrl,
      imgUrl,
      nameUrl,
    };
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/style.scss";
.why-us {
  height: 100%;
  &_banner {
    height: 413px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    &_title {
      text-align: center;
      position: absolute;
      text-transform: uppercase;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      font-weight: 900;
      font-size: var(--big-font-size);
      line-height: 45px;
      text-align: center;
      letter-spacing: 0.155em;

      color: #ffffff;
    }
    &_sub-title {
      font-weight: 600;
      font-size: var(--normal-font-size);
      line-height: 22px;
      letter-spacing: -0.02em;
      position: absolute;
      bottom: 3%;
      left: 0%;
      color: #2b938c;
      background: #f8f7f7;
      padding: 10px 40px;
      width: 100%;
    }
  }
  h1 {
    text-align: center;
    font-weight: 900;
    font-size: var(--big-font-size);
    line-height: 45px;
    text-align: center;
    letter-spacing: 0.155em;
    color: #2b938c;
    padding: 100px;
  }
}
</style>